import { Injectable } from '@nestjs/common';
import { Repository, Raw, getConnection, DataSource } from 'typeorm';
import { ThreadsDto } from './dto/threads.dto';
import { ThreadsEntity } from './threads.entity';
import { ThreadsAdapter } from './dto/threads.adapter';
import { AllThreadsResponseModel, EmbroideryThreadColumns, CommonResponseModel, ItemsResponseModel, ThreadsResponseModel, ExternalReq, EmbroideryThreadReq, QtyTypeEnum, ThreadsUpdateReq } from '@project-management-system/shared-models';
import { InjectRepository } from '@nestjs/typeorm';
import { ThreadRequest } from './dto/threads.request';
import { ThreadsRepository } from './threads.repo';
import { ThreadsEmbroideryRepository } from './embroidery-thread.repo';
import { GenericTransactionManager } from '../../typeorm-transactions';
import { ThreadsEmbroideryEntity } from './embroidery-thread.entity';
import { ThreadQtyRepo } from '../thread-qty/thread-qty.repo';

@Injectable()
export class ThreadsService {

  constructor(

    private threadsRepository: ThreadsRepository,
    private threadAdapter: ThreadsAdapter,
    private threadsEmbroideryRepo: ThreadsEmbroideryRepository,
    private threadQtyRepo: ThreadQtyRepo,
    private dataSource: DataSource,
  ) { }

  async getThreadDetailsWithoutRelations(threadId: number): Promise<ThreadsEntity> {
    const itemResponse = await this.threadsRepository.findOne({
      where: { threadId: threadId },
    });
    if (itemResponse) {
      return itemResponse;
    } else {
      return null;
    }
  }

  async createThread(threadDto: ThreadsDto, isUpdate: boolean): Promise<ThreadsResponseModel> {
    try {
      let previousValue
      if (!isUpdate) {
        // const ThreadEntity = await this.getThreadDetailsWithoutRelations(threadDto.threadId);
        // if (ThreadEntity) {
        //   throw new ThreadsResponseModel(false,11104, 'Thread already exists');
        // }
      }
      else {
        const certificatePrevious = await this.threadsRepository.findOne({ where: { threadId: threadDto.threadId } })
        previousValue = certificatePrevious.threadId
        const threadEntity = await this.getThreadDetailsWithoutRelations(threadDto.threadId);
        if (threadEntity) {
          if (threadEntity.threadId != threadDto.threadId) {
            throw new ThreadsResponseModel(false, 11104, 'Threads already exists');
          }
        }
      }
      const convertedThreadEntity: ThreadsEntity = this.threadAdapter.convertDtoToEntity(threadDto, isUpdate);
      const savedThreadEntity: ThreadsEntity = await this.threadsRepository.save(convertedThreadEntity);
      const savedThreadDto: ThreadsDto = this.threadAdapter.convertEntityToDto(savedThreadEntity);
      if (savedThreadDto) {
        const presentValue = savedThreadDto.tex;
        const response = new ThreadsResponseModel(true, 1, isUpdate ? 'Threads Updated Successfully' : 'Threads Created Successfully');
        const name = isUpdate ? 'updated' : 'created'
        const displayValue = isUpdate ? 'Threads Updated Successfully' : 'Threads Created Successfully'
        const userName = isUpdate ? savedThreadDto.updatedUser : savedThreadDto.createdUser;

        return response
      } else {
        throw new ItemsResponseModel(false, 11106, 'Threads saved but issue while transforming into DTO');
      }
    } catch (error) {

      return error;
    }
  }

  async getAllThreads(): Promise<CommonResponseModel> {
    const data = await this.threadsRepository.getThreadsData()
    if (data.length > 0)
      return new CommonResponseModel(true, 1, 'data retrived', data)
    else
      return new CommonResponseModel(false, 0, 'No data found');
  }

  async getAllActiveThreads(): Promise<AllThreadsResponseModel> {
    // const page: number = 1;
    try {
      const threadsDtos: ThreadsDto[] = [];
      //retrieves all companies
      const threadEntities: ThreadsEntity[] = await this.threadsRepository.find({
        order: { 'tex': 'ASC' }, where: { isActive: true }
      });
      //  console.log(CurrenciesEntities)
      if (threadEntities) {
        // converts the data fetched from the database which of type companies array to type StateDto array.
        threadEntities.forEach(tex => {
          const convertedItemDtos: ThreadsDto = this.threadAdapter.convertEntityToDto(
            tex
          );
          threadsDtos.push(convertedItemDtos);
        });
        const response = new AllThreadsResponseModel(true, 11108, "Threads retrieved successfully", threadsDtos);
        return response;
      } else {
        throw new AllThreadsResponseModel(false, 99998, 'Data not found'); threadsDtos
      }
    } catch (err) {
      return err;
    }
  }

  async getThreadsTrimsData(req: any): Promise<CommonResponseModel> {
    const records = await this.threadsRepository.getThreadsTrimsData(req);
    let data: any[] = []
    for (const record of records) {
      if (record.qty > 10000) {
        const qtyData = await this.threadQtyRepo.findOne({ where: { tex: record.tex, quality: record.quality, qty: QtyTypeEnum['>10K'] } })
        if (qtyData)
          record.mtrs_per_cone = qtyData.mtrsPerCone
        else
          return new CommonResponseModel(false, 0, 'Data not found, Update latest Maters')
        data.push(record)
      } else {
        data.push(record)
      }
    }
    const combinedData = await this.threadsRepository.getCombinedThreadsTrimData(req);

    const mergedData = [...data, ...combinedData];

    if (mergedData.length > 0)
      return new CommonResponseModel(true, 1, 'Data retrieved', mergedData);
    else
      return new CommonResponseModel(false, 0, 'No data found');
  }

  async getEmbroideryThreadsTrimsData(req: ExternalReq): Promise<CommonResponseModel> {
    const data = await this.threadsEmbroideryRepo.getEmbroideryThreadsTrimsData(req)
    if (data.length > 0)
      return new CommonResponseModel(true, 1, 'data retrived', data)
    else
      return new CommonResponseModel(false, 0, 'No data found');
  }

  async SaveEmbrodieryThreadExcel(formData: any): Promise<CommonResponseModel> {
    const transactionManager = new GenericTransactionManager(this.dataSource);
    try {
      await transactionManager.startTransaction()
      const flag = new Set<boolean>()
      const columnArray = []
      const updatedArray = formData.map((obj) => {
        const updatedObj = {}
        for (const key in obj) {
          const newKey = key.replace(/\s/g, '').replace(/[\(\)\.]/g, '').replace(/-/g, '').replace(/#/g, '');
          if (newKey != '') {
            columnArray.push(newKey);
            updatedObj[newKey] = obj[key];
          }
        }
        return updatedObj;
      })
      const difference = columnArray.filter((element) => !EmbroideryThreadColumns.includes(element));
      console.log(difference, "diff")
      if (difference.length > 0) {
        await transactionManager.releaseTransaction();
        return new CommonResponseModel(false, 1110, "Excel columns doesn't match. Please attach the correct file.");
      }
      const convertedData = updatedArray.map((obj) => {
        const updatedObj = {};
        for (const key in obj) {
          const value = obj[key];
          if (value === "") {
            updatedObj[key] = null;
          } else {
            updatedObj[key] = value;
          }
        }
        return updatedObj;
      });
      // for (const data of convertedData) {
      //   console.log(data, "iiiiii")
      //   if (data) {
      //     const addObj = new ThreadsEmbroideryEntity()
      //     addObj.productCode = data.product_code
      //     addObj.color = data.color
      //     addObj.shadeNumber = data.shade_number
      //     addObj.tex = data.tex
      //     addObj.consumption = data.consumption
      //     addObj.mtrsPerCone = data.mtrs_per_cone
      //     const addSave = await transactionManager.getRepository(ThreadsEmbroideryEntity).save(addObj)
      //     if (addSave) {
      //       flag.add(true)
      //     } else {
      //       flag.add(false)
      //       await transactionManager.releaseTransaction();
      //       break;
      //     }
      //   }
      // }
      for (const data of convertedData) {
        if (data) {
          let existingObj = await transactionManager.getRepository(ThreadsEmbroideryEntity).findOne({
            where: {
              productCode: data.product_code, color: data.color, shadeNumber: data.shade_number,
              tex: data.tex, consumption: data.consumption, mtrsPerCone: data.mtrs_per_cone
            }
          });

          if (existingObj) {
            existingObj.productCode = data.product_code;
            existingObj.color = data.color;
            existingObj.shadeNumber = data.shade_number;
            existingObj.tex = data.tex;
            existingObj.consumption = data.consumption;
            existingObj.mtrsPerCone = data.mtrs_per_cone;

            const updateResult = await transactionManager.getRepository(ThreadsEmbroideryEntity).save(existingObj);
            if (!updateResult) {
              flag.add(false);
              await transactionManager.releaseTransaction();
              break;
            }
          } else {
            // Insert new record
            const addObj = new ThreadsEmbroideryEntity();
            addObj.productCode = data.product_code;
            addObj.color = data.color;
            addObj.shadeNumber = data.shade_number;
            addObj.tex = data.tex;
            addObj.consumption = data.consumption;
            addObj.mtrsPerCone = data.mtrs_per_cone;

            const addSave = await transactionManager.getRepository(ThreadsEmbroideryEntity).save(addObj);
            if (!addSave) {
              flag.add(false);
              await transactionManager.releaseTransaction();
              break;
            }
          }
        }
      }
      if (!flag.has(false)) {
        await transactionManager.completeTransaction();
        return new CommonResponseModel(true, 1, 'Data saved successfully');
      } else {
        await transactionManager.releaseTransaction();
        return new CommonResponseModel(false, 0, 'Something went wrong');
      }
    } catch (err) {
      await transactionManager.releaseTransaction();
      return new CommonResponseModel(false, 0, 'Something went wrong');
    }
  }

  async getEmbrodieryThreadExcel(): Promise<CommonResponseModel> {
    try {
      const info = await this.threadsEmbroideryRepo.find()
      if (info) {
        return new CommonResponseModel(true, 1, 'Data retrieved', info)
      } else {
        return new CommonResponseModel(false, 0, 'No data found')
      }
    } catch (err) {
      return new CommonResponseModel(false, 0, 'Something went wrong', err)
    }
  }

  async updateEmbrodieryThreadExcel(req?: EmbroideryThreadReq): Promise<CommonResponseModel> {
    console.log(req, "req");

    try {
      let query =
        `UPDATE threads_embroidery
          SET 
              product_code = '${req.productCode}',
              color = '${req.color}',
              shade_number = '${req.shadeNumber}',
              tex = '${req.tex}',
              consumption = ${req.consumption},
              mtrs_per_cone = ${req.mtrsPerCone}
          WHERE id = "${req.id}"`

      const result = await this.threadsEmbroideryRepo.query(query)
      if (result) {
        return new CommonResponseModel(true, 1, 'Updated Successfully', result)
      }
    }

    catch (err) {
      return new CommonResponseModel(false, 0, err.message)
    }
  }

  async saveThreadsMasterExcel(formData: any): Promise<CommonResponseModel> {
    const transactionManager = new GenericTransactionManager(this.dataSource);
    try {
      await transactionManager.startTransaction();
      const flag = new Set<boolean>();
      const styleArray: any[] = [];
      const texArray: { tex: any, part: any, quality: any }[] = [];

      // Populate styleArray and texArray from formData
      for (const data of formData) {
        if (data.style_id) {
          styleArray.push(data.style_id);
        }
        if (data.tex) {
          texArray.push({ tex: data.tex, part: data.part, quality: data.quality });
        }
      }

      for (const style of styleArray) {
        for (const texdata of texArray) {
          for (const data of formData) {
            if (data.colour_code) {
              const addObj = new ThreadsEntity();
              addObj.styleId = style;
              addObj.tex = texdata.tex;
              addObj.part = texdata.part;
              addObj.quality = texdata.quality;
              addObj.shadeNumber = data.shade_number.toString();
              addObj.colorCombo = data.colour_combo;
              addObj.colorCode = data.colour_code.toString();
              addObj.supplierId = data.supplier === 'Coats' ? 1 : (data.supplier === 'Amann' ? 3 : 2);

              const record = await transactionManager.getRepository(ThreadsEntity).findOne({
                where: { styleId: style, tex: texdata.tex, quality: texdata.quality, colorCode: data.colour_code.toString() }
              });
              if (!record) {
                const addSave = await transactionManager.getRepository(ThreadsEntity).save(addObj);
                if (addSave) {
                  flag.add(true);
                } else {
                  flag.add(false);
                  await transactionManager.releaseTransaction();
                  return new CommonResponseModel(false, 0, 'Something went wrong');
                }
              } else if (record) {
                const update = await transactionManager.getRepository(ThreadsEntity).update(
                  { styleId: style, tex: texdata.tex, quality: texdata.quality, colorCode: data.colour_code.toString() },
                  { part: texdata.part, shadeNumber: data.shade_number.toString(), colorCombo: data.colour_combo, supplierId: data.supplier === 'Coats' ? 1 : (data.supplier === 'Amann' ? 3 : 2) }
                );

                if (!update.affected) {
                  await transactionManager.releaseTransaction();
                  return new CommonResponseModel(false, 0, 'Error while updating');
                }
              }
            }
          }
        }
      }

      if (!flag.has(false)) {
        await transactionManager.completeTransaction();
        return new CommonResponseModel(true, 1, 'Data saved successfully');
      } else {
        await transactionManager.releaseTransaction();
        return new CommonResponseModel(false, 0, 'Something went wrong');
      }
    } catch (err) {
      await transactionManager.releaseTransaction();
      return new CommonResponseModel(false, 0, err.message);
    }
  }

  async updateThreadsExcel(req?: ThreadsUpdateReq): Promise<CommonResponseModel> {
    console.log(req, "req");

    try {
      let query =
        ` UPDATE threads
    SET
        style_Id = '${req.style}',
        supplier_Id = ${req.supplierName},
        tex = '${req.tex}',
        part = '${req.part}',
        quality = '${req.quality}',
        color_combo = '${req.colorCombo}',
        color_code = '${req.colorCode}',
        shade_number = '${req.shadeNumber}'
    WHERE thread_id = ${req.id};
`

      const result = await this.threadsRepository.query(query)
      if (result) {
        return new CommonResponseModel(true, 1, 'Updated Successfully', result)
      }
    }
    catch (err) {
      return new CommonResponseModel(false, 0, err.message)
    }
  }

}

